import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, } from 'react';
import { Minus, Plus } from '../Icons';
import { QuantityInputProvider, useQuantityInputContext } from './context';
import * as Styles from './styles';
function QuantityInputWrapper({ children, id, disabled = false, ...rest }) {
    return (_jsx(QuantityInputProvider, { value: { disabled, id }, children: _jsx(Styles.Wrapper, { disabled: disabled, ...rest, children: children }) }));
}
function QuantityInputInput({ value, onChange, fullWidth, ...rest }) {
    const { disabled, id } = useQuantityInputContext();
    const handleChange = e => {
        const { value } = e.target;
        const parsed = isNaN(parseInt(value)) ? undefined : parseInt(value);
        if (!disabled && onChange)
            onChange(parsed);
    };
    return (_jsx(Styles.InputWrapper, { children: _jsx(Styles.Input, { id: id, type: 'number', onChange: handleChange, value: value === undefined ? '' : value.toString(), disabled: disabled, "aria-live": 'polite', "aria-label": `Quantity ${value}`, fullWidth: fullWidth, ...rest }) }));
}
function QuantityInputControl({ increment, decrement, disabled, onClick, children, ...rest }) {
    const { disabled: parentDisabled, id } = useQuantityInputContext();
    const icon = useMemo(() => {
        if (increment)
            return _jsx(Plus, {});
        if (decrement)
            return _jsx(Minus, {});
        return undefined;
    }, [decrement, increment]);
    const label = useMemo(() => {
        if (increment)
            return 'Increase quantity by one';
        if (decrement)
            return 'Decrease quantity by one';
        return undefined;
    }, [increment, decrement]);
    const buttonDisabled = Boolean(parentDisabled || disabled);
    const handleClick = e => {
        if (!buttonDisabled && onClick)
            onClick(e);
    };
    return (_jsx(Styles.ControlButton, { type: 'button', onClick: handleClick, "aria-disabled": buttonDisabled, "aria-controls": id, "aria-label": label ?? undefined, ...rest, children: icon ?? children }));
}
export const QuantityInput = {
    Wrapper: QuantityInputWrapper,
    Control: QuantityInputControl,
    Input: QuantityInputInput,
};
//# sourceMappingURL=index.js.map